export const ERROR_MESSAGE = {
  INVALID_USER_ID: 'ログアウトします',
  INVALID_USER_TYPE: 'ProDoctorsの医療機関側のURLで再度お試しください。',
  TOKEN_EXPIRED: '認証の有効期限が切れました。再ログインしてください。',
};
